import React from 'react';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import LayoutAdminHeader from '../components/LayoutAdminHeader';
import LayoutAdminFooter from '../components/LayoutAdminFooter';
import GSTLoader from '../components/GSTLoader'; // Import GSTLoader 
const AdminDashboard = () => {
  const cards = [
    {
      title: 'Total Users',
      value: 120,
      icon: <GroupOutlinedIcon sx={{ fontSize: 50, color: '#1976d2' }} />,
      bgColor: '#e3f2fd', // Light Blue
    },
    {
      title: 'Sales Today',
      value: '₹15,000',
      icon: <AttachMoneyOutlinedIcon sx={{ fontSize: 50, color: '#2e7d32' }} />,
      bgColor: '#e8f5e9', // Light Green
    },
    {
      title: 'Invoices Generated',
      value: 75,
      icon: <DescriptionOutlinedIcon sx={{ fontSize: 50, color: '#f9a825' }} />,
      bgColor: '#fffde7', // Light Yellow
    },
    {
      title: 'Pending Tasks',
      value: 10,
      icon: <PendingActionsOutlinedIcon sx={{ fontSize: 50, color: '#d32f2f' }} />,
      bgColor: '#ffebee', // Light Red
    },
  ];

  return (
    <GSTLoader>
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header */}
      <LayoutAdminHeader />

      {/* Main Content */}
      <Box sx={{ flex: 1, p: 4 }}>
        <Typography
  variant="h4"
  align="center"
  gutterBottom
  sx={{
    fontWeight: 600,
    fontFamily: "'Poppins', sans-serif",
    mb: 4,
    color: '#003366' // blue color
  }}
>
  {/* Admin Dashboard */}
</Typography>


        {/* Cards Grid */}
        {/* <Grid container spacing={4} justifyContent="center">
          {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Card
                sx={{
                  backgroundColor: card.bgColor,
                  borderRadius: 3,
                  px: 3,
                  py: 4,
                  boxShadow: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '100%',
                  transition: '0.3s',
                  '&:hover': {
                    boxShadow: 5,
                    transform: 'translateY(-3px)',
                  },
                }}
              >
                <Box>{card.icon}</Box>
                <Box sx={{ textAlign: 'right' }}>
                  <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', fontWeight: 500 }}>
                    {card.title}
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
                    {card.value}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid> */}
      </Box>

      {/* Footer */}
      <LayoutAdminFooter />
    </div>
    </GSTLoader>
  );
};

export default AdminDashboard;
